import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {VirtualScrollerModule} from 'ngx-virtual-scroller';
import {PrimePetalLongModule} from 'src/app/ui/shared/modules/prime-petal-long/prime-petal-long.module';
import {OfferPetalModule} from '../offer-petal/offer-petal.module';
import {ProductImageComponent} from './product-image.component';
import {IconsModule} from '../icons/icons.module';

@NgModule({
  declarations: [ProductImageComponent],
  imports: [
    CommonModule,
    IconsModule,
    RouterModule,
    VirtualScrollerModule,
    PrimePetalLongModule,
    OfferPetalModule,
  ],
  exports: [ProductImageComponent],
})
export class ProductImageModule {}
